export interface PasswordCheck {
  label: string;
  passed: boolean;
}

export interface PasswordStrength {
  score: number; // 0-3 (weak, fair, good, strong)
  isValid: boolean;
  checks: PasswordCheck[];
}

export function validatePasswordStrength(password: string): PasswordStrength {
  const checks: PasswordCheck[] = [
    { label: "At least 8 characters", passed: password.length >= 8 },
    { label: "Contains uppercase letter", passed: /[A-Z]/.test(password) },
    { label: "Contains lowercase letter", passed: /[a-z]/.test(password) },
    { label: "Contains a number", passed: /\d/.test(password) },
    { label: "Contains special character (!@#$...)", passed: /[^A-Za-z0-9]/.test(password) },
  ];

  const passedCount = checks.filter((c) => c.passed).length;

  let score: number;
  if (passedCount <= 1) score = 0;
  else if (passedCount <= 3) score = 1;
  else if (passedCount === 4) score = 2;
  else score = 3;

  const isValid = checks[0].passed && checks[1].passed && checks[2].passed && checks[3].passed;

  return { score, isValid, checks };
}
